// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"form_wrapper___GNWZ","column":"form_column__NQI1i","text":"form_text__AphOY","image":"form_image__9khD3","form":"form_form__VqQhR","success":"form_success__C_Lca"};